import { t } from 'i18next';
import { memo, useEffect } from 'react';
import { TabNameLocalizationKeys } from '../../routing/routes';

type Props = {
  loading: boolean;
  fragments: string[];
};

export const DocumentTitle = memo(
  ({ loading, fragments }: Props) => {
    useEffect(() => {
      const items = loading ? [t('a11y.general.loading')] : fragments.filter((f) => f !== t(TabNameLocalizationKeys.HOME));
      const title = [...items.reverse(), 'AQtive Guard'].join(' - ');
      document.title = title;
    }, [fragments, loading]);
    return null;
  },
  (prevProps, nextProps) => prevProps.loading === nextProps.loading && prevProps.fragments.join('_') === nextProps.fragments.join('_')
);
